import React, { useCallback } from "react";
import PropTypes from "prop-types";

import { useBooleanState } from "hooks";

import { Button, CouponForm, CouponMessage, Icon } from "..";

function CouponInformation({
  id,
  discountAmount,
  discountDetails,
  validating,
  error,
  currency,
  hasExistingCoupon,
  onCouponApplied,
  onCouponRemoved,
}) {
  const [showCouponForm, openCouponForm, closeCouponForm] =
    useBooleanState(false);

  const handleDismiss = useCallback(() => {
    if (hasExistingCoupon) return null;

    return !validating ? onCouponRemoved : () => {};
  }, [validating, hasExistingCoupon, onCouponRemoved]);

  return (
    <CouponMessage
      code={id}
      discountAmount={discountAmount}
      discountDetails={discountDetails}
      currency={currency}
      loading={validating}
      onDismiss={handleDismiss()}
    >
      {hasExistingCoupon && !showCouponForm && (
        <Button
          primary
          size="mini"
          style={{ marginTop: "10px" }}
          onClick={openCouponForm}
        >
          Replace Coupon
        </Button>
      )}
      {hasExistingCoupon && showCouponForm && (
        <CouponForm
          loading={validating}
          error={error}
          onApply={(c) => {
            return onCouponApplied(c).then((resp) => {
              if (resp && !resp.couponError) closeCouponForm();
            });
          }}
        >
          <Button
            icon
            type="button"
            disabled={validating}
            onClick={closeCouponForm}
          >
            <Icon
              data-test="close-replace-coupon-icon"
              name="close"
              disabled={validating}
            />
          </Button>
        </CouponForm>
      )}
    </CouponMessage>
  );
}

CouponInformation.propTypes = {
  id: PropTypes.string,
  discountAmount: PropTypes.string,
  discountDetails: PropTypes.string,
  validating: PropTypes.bool,
  error: PropTypes.string,
  hasExistingCoupon: PropTypes.bool,
  currency: PropTypes.string,
  onCouponApplied: PropTypes.func.isRequired,
  onCouponRemoved: PropTypes.func.isRequired,
};

CouponInformation.defaultProps = {
  id: "",
  discountAmount: "",
  discountDetails: "",
  validating: false,
  error: "",
  currency: "USD",
  hasExistingCoupon: false,
};

export default CouponInformation;
